import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ThreeBand } from "./ThreeBand";

const HERO_IMG = `${process.env.PUBLIC_URL}/img/hero.jpg`;

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (d) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: d },
  }),
};

export const Hero = ({ onContact }) => {
  return (
    <section className="mac-section" data-testid="hero-section" style={{ paddingTop: 130, paddingBottom: 100 }}>
      <div className="mac-container" style={{ position: "relative", zIndex: 1 }}>
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - content */}
          <div>
            <motion.div variants={fadeUp} custom={0} initial="hidden" animate="show">
              <div className="mac-eyebrow-row">
                <ThreeBand />
                <p className="mac-eyebrow" data-testid="hero-eyebrow">
                  <span style={{ color: "var(--pink)" }}>LUXURY FASHION</span>
                  <span style={{ color: "var(--white)", opacity: 0.45 }}> · </span>
                  <span style={{ color: "var(--iris)" }}>SKINCARE</span>
                  <span style={{ color: "var(--white)", opacity: 0.45 }}> · </span>
                  <span style={{ color: "var(--cyan)" }}>COSMETICS</span>
                </p>
              </div>
            </motion.div>

            <motion.h1
              variants={fadeUp}
              custom={0}
              initial="hidden"
              animate="show"
              className="mac-display"
              data-testid="hero-headline"
              style={{ fontSize: "clamp(32px, 4.4vw, 54px)", marginTop: 24 }}
            >
              Increase in-store sales. <span className="mac-gradient-text">Cut your team's workload in half.</span>
            </motion.h1>

            <motion.p
              variants={fadeUp}
              custom={0.2}
              initial="hidden"
              animate="show"
              className="mac-body"
              data-testid="hero-subheadline"
              style={{ fontSize: 18, marginTop: 24, maxWidth: 560 }}
            >
              Your AI copilot to automatically design store-specific displays, predict which products will
              sell best, and verify every store matches the master plan. The only AI software created by a
              visual merchandising expert.
            </motion.p>

            <motion.div
              variants={fadeUp}
              custom={0.4}
              initial="hidden"
              animate="show"
              style={{ marginTop: 32 }}
            >
              <button className="mac-btn" data-testid="hero-cta-btn" onClick={onContact}>
                Contact Us <ArrowRight size={15} strokeWidth={2.5} />
              </button>
            </motion.div>
          </div>

          {/* Right - hero image */}
          <motion.div
            variants={fadeUp}
            custom={0.3}
            initial="hidden"
            animate="show"
            className="mac-hero-visual"
            data-testid="hero-image"
          >
            <div className="mac-hero-glow" />
            <div className="mac-hero-frame">
              <img src={HERO_IMG} alt="Luxury visual merchandising store" className="mac-hero-img" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
